<template>
    <div>
        <input
            :id="innerId"
            :checked="modelValue === value"
            :name="name"
            :value="value"
            class="cr-radio"
            type="radio"
            @change="changed($event)"
        />
        <label :for="innerId">
            <span v-if="label">
                {{ label }}
            </span>
            <span v-else>
                <wbr />
            </span>
        </label>
    </div>
</template>

<script>
    export default {
        compatConfig: { COMPONENT_V_MODEL: false },

        name: 'Radio',

        model: {
            prop: 'modelValue',
            event: 'change',
        },

        props: {
            modelValue: {
                default: null,
            },
            value: {
                default: '',
            },
            id: String,
            label: String,
            name: String,
        },

        data() {
            let innerId;

            if (this.id) {
                innerId = this.id;
            } else
                do {
                    innerId = `selectable-${Math.floor(Math.random() * 1000000)}`;
                } while (document.getElementById(innerId));

            return { innerId };
        },

        methods: {
            changed(event) {
                if (event.target.checked) {
                    this.$emit('change', this.value); // Vue 2
                    this.$emit('update:modelValue', this.value); // Vue 3
                }
            },
        },
    };
</script>
